// Ausgelagerte Konstanten für Webapp
import { defaults } from 'axios'
export { setApiUrl, tokenName, routes, tileProviders, attribution }

var selectedApiUrl = 'default'
// 'default' = Für Entwicklung wird Dev, für Build wird Prod verwendet
// 'dev' = Dev wird verwendet
// 'prod' = Prod wird verwendet
const apiUrlDev = 'http://localhost:4000/api/'
const apiUrlProd = 'https://mitfahren.digikabu.de/api/'

function setApiUrl() { // Methode setzt entsprechende API-Url in axios abhängig von 'selectedApiUrl'
    if (selectedApiUrl == 'dev')
        defaults.baseURL = apiUrlDev
    else if (selectedApiUrl == 'prod')
        defaults.baseURL = apiUrlProd
    else if (process.env.NODE_ENV == 'development')
        defaults.baseURL = apiUrlDev
    else
        defaults.baseURL = apiUrlProd
}

const tokenName = 'bszwmloginToken' // Cookie-Name für Token
const routes = [ // Routen für Vue-Router
    {
        name: 'Suchen',
        path: '/',
        component: () => import('./views/Uebersicht.vue'),
        meta: { nav: true, icon: 'search.svg' }
    },
    {
        name: 'Login',
        path: '/login',
        component: () => import('./views/Login.vue'),
        meta: { nav: false }
    },
    {
        name: 'Register', path: '/register',
        component: () => import('./views/Register.vue'),
        meta: { nav: false }
    },
    {
        name: 'Nachrichten',
        path: '/nachrichten',
        component: () => import('./views/Anfragen.vue'),
        meta: { nav: true, icon: 'chat.svg' }
    },
    {
        name: 'Einstellungen',
        path: '/einstellungen',
        component: () => import('./views/Einstellungen.vue'),
        meta: { nav: true, icon: 'settings.svg' }
    },
    {
        name: 'Über',
        path: '/ueber',
        alias: '/impressum',
        component: () => import('./views/Ueber.vue'),
        meta: { nav: true, icon: 'mug.svg' }
    },
    {
        name: 'NotFound',
        path: '*',
        component: () => import('./views/Ueber.vue'),
        meta: { nav: false }
    }
]

// Urls und Attribution für Stadia-Maps inkl Fallback-Url auf Openstreetmaps
const tileProviders = [
    {
        name: 'Alidade Smooth',
        url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png',
        icon: require('./assets/logos/stadia.svg')
    },
    {
        name: 'Alidade Dark',
        url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
        icon: require('./assets/logos/stadia.svg')
    },
    {
        name: 'Open Street Map',
        url: 'https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png',
        icon: require('./assets/logos/openstreetmap.svg')
    }
]

const attribution = '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'